import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { Box, Card, Typography } from '@mui/material'
import React from 'react'

import Button from '@/components/Button'

interface CardProps {
  title: string
  textBackground: string
  mainDescription: string
  price: number
  duration: string
  recipeDescription: string
  onStartTrial: () => void
  bestValue?: boolean
  buttonText: string
  index: number
  isDisabled: boolean
  planName: string
  selectedPlan: string
  disableButton?: boolean
}

const PlanCard: React.FC<CardProps> = (props) => {
  const {
    title,
    textBackground,
    mainDescription,
    price,
    duration,
    recipeDescription,
    onStartTrial,
    bestValue,
    buttonText,
    index,
    isDisabled,
  } = props
  return (
    <Card
      sx={{
        paddingTop: '2rem',
        minHeight: '26.13rem',
        width: { xs: '100%', sm: '100%', md: '18.06rem' },
        gap: '1rem',
        borderRadius: '0.5rem',
        backgroundColor: '#2E2E2E',
        boxShadow:
          '0px 9px 46px 8px rgba(0, 0, 0, 0.40), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 11px 15px -7px rgba(0, 0, 0, 0.20)',
        opacity: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Box
        display={'flex'}
        flexDirection={'column'}
        alignItems={'center'}
        gap={'1rem'}
      >
        <Box
          padding={index === 1 ? '1rem 3rem' : '1rem 3.5rem'}
          alignItems={'center'}
          display={'flex'}
          flexDirection={'column'}
          gap={'0.5rem'}
        >
          <Typography
            sx={{
              whiteSpace: 'nowrap',
              fontSize: '1.5rem',
              fontWeight: 700,
              letterSpacing: '-0.015rem',
              background: `${textBackground}`,
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              color: '#fff',
              fontSize: '0.8125rem',
              fontWeight: 400,
              textAlign: 'center',
            }}
          >
            {mainDescription}
          </Typography>
        </Box>
        <Box component={'span'}>
          <Typography
            sx={{
              fontSize: '3rem',
              lineHeight: '3.5rem',
              letterSpacing: '-0.03rem',
              fontWeight: 600,
              color: 'white',
              textAlign: 'center',
            }}
          >
            €{price}
          </Typography>

          <Typography
            sx={{
              fontWeight: 400,
              fontSize: '0.875rem',
              color: 'white',
              textAlign: 'center',
            }}
          >
            {duration}
          </Typography>
        </Box>
      </Box>

      <Box
        width="100%"
        display="flex"
        justifyContent="center"
        alignItems="center"
        mb="1rem"
      >
        <Button
          label={buttonText}
          sx={{ bgcolor: '#FF47A0', color: 'white', width: '90%' }}
          disabled={isDisabled}
          onClick={onStartTrial}
        />
      </Box>

      {recipeDescription && (
        <Box
          display={'flex'}
          justifyContent={'start'}
          alignItems={'flex-start'}
          flexDirection={'column'}
          gap={'1rem'}
          color={'#fff'}
          minHeight={'7.5rem'}
          width={'100%'}
          padding={'1rem'}
          style={{ background: '#1e1e1e' }}
          sx={{
            height: 'auto',
            textAlign: 'left',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
          }}
        >
          {bestValue ? (
            <Box
              fontWeight={600}
              textAlign={'center'}
              sx={{
                fontSize: '1rem',
                textAlign: 'left',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
              }}
            >
              ALL-IN-ONE Package
            </Box>
          ) : null}
          <Box
            component={'span'}
            display={'flex'}
            alignItems={'center'}
            gap={'0.5rem'}
          >
            <ChevronRightIcon />
            <Box
              component={'p'}
              sx={{
                fontWeight: 400,
                fontSize: '1rem',
                margin: 0,
              }}
            >
              {recipeDescription}
            </Box>
          </Box>
        </Box>
      )}
    </Card>
  )
}

export default PlanCard
